import "./token.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "../store/provider.mjs";
import "@deorderbook/contracts";
import "../store/subgraph.mjs";
import { useUSDCContract as r } from "../store/usdcContract.mjs";
function c(t) {
  return r().balanceOf(t);
}
function m(t, o) {
  return r().allowance(t, o);
}
function f(t, o) {
  return r(!0).approve(t, o);
}
function S() {
  return r().totalSupply();
}
export {
  m as allowance,
  f as approve,
  c as balanceOf,
  S as totalSupply
};
//# sourceMappingURL=token_usdc.mjs.map
